<template>
  <div id="date-range-container" class="dropdown">
      <base-input
        id="date-input-field"
        label=""
        type="text"
        field="dateRange"
        :enableTextboxStyle="false"
        value=""
        :remove_default_margin="true"
        cus_style="
          margin-bottom: 0; 
          width: 6em; 
          height: 2em;
          font-family: Quicksand-SemiBold;
          cursor: pointer;
          caret-color: transparent;
        "
      >
        <template v-slot:prefix>
          <div class="date-label">
            {{ dateRangeLabel }}
          </div>
        </template>
      </base-input>
      <div class="content-container dropdown-menu-1"
          :style="right?'right:0': 'left:0'"
          v-if="showDatepicker"
          >
          <b-row tabindex="0" class="no-gutter my-2 p-2"> <!-- tab index makes it focusable -->
            <b-col cols="12" class="label-list" v-if="!showCustomRange">
              <div
                v-for="(label, index) in dateRangeLabels"
                :class="[
                  'label-list-item',
                  { active: dateRangeLabel === label ? true : false },
                ]"
                :key="index"
                @click.stop="setDateRange(label)"
              >
                {{ label }}
              </div>
            </b-col>
            <b-col v-else>
              <b-col cols="12" style="display: flex; flex-direction: column;">
                <span class="cal-label">From</span>
                <v-date-picker 
                  v-if="type=='date'"
                  ref="startSelector"
                  :select-attribute="attribute"
                  :drag-attribute="attribute"
                  :class="[{show: showDatepicker}, 'no-border']"
                  :value="dateRange.start"
                  @dayclick="(...args) => handleDayClick('start',...args)"
                  is-required
              />
              <month-picker 
              v-if="type=='month'" 
              ref="startMonthSelector"
              :default-month="monthRange.from.monthIndex"
              :default-year="monthRange.from.year"
              @change="(...args) => handleMonthClick('start',...args)" 
              is-required>
            </month-picker>
            </b-col>
            <b-col cols="12" style="display: flex; flex-direction: column;">
              <span class="cal-label">To</span>
              <v-date-picker 
              v-if="type=='date'"
              ref="endSelector"
              :select-attribute="attribute"
              :drag-attribute="attribute"
              :class="[{show: showDatepicker}, 'no-border']"
              @dayclick="(...args) => handleDayClick('end',...args)"
              :value="dateRange.end"
              is-required
              />
              <month-picker  
              ref="endMonthSelector" 
              v-if="type=='month'" 
              :default-month="monthRange.to.monthIndex || new Date().getMonth()+1"
              :default-year="monthRange.to.year || new Date().getMonth()+1"
              @change="(...args) => handleMonthClick('end',...args)" 
              is-required>
            </month-picker>
            </b-col>
            </b-col>
          </b-row>
        </div>
      </div>
</template>

<script>
import BaseInput from '@/components/UI/BaseInput.vue';
import { DateTime } from 'luxon';
import { MonthPickerInput } from 'vue-month-picker'
import { MonthPicker } from 'vue-month-picker'

export default {
  name: "mobile-date-range-picker",
  props: {
    attribute: {
      required: true,
      type: Object,
    },
    dateRange: {
      required: true,
      type: Object,
    },
    ranges: {
      required: true,
      type: Object,
    },
    preventEmit: {
      required: true,
      type: Boolean,
    },
    dateRangeLabel: {
      required: false,
      default: null,
    },
    avoidUpdatingLabel: {
      required: true,
      type: Boolean,
    },
    showDatepicker: {
      required: true,
      type: Boolean,
    },
    header: {
      required: true,
      type: String,
    },
    right: {
      required: false,
      type: Boolean,
    },
    type: {
      required: true,
      type: String,
    },
  },
  data() {
    return { 
      showCustomRange: false,
      monthRange: {
        "from": null,
        "to": null,
      },
    };
  },
  components: {
    BaseInput,
    MonthPickerInput,
    MonthPicker
  },
  mounted(){
    if (this.dateRange || this.dateRangeLabel) {
      this.setMonthRanges(new Date(this.dateRange.start), new Date(this.dateRange.end));
    }
  },
  methods: {
    handleDayClick(dateType, dateObj) {
      if(dateType == 'start'){
        var diffIndays = Math.ceil(DateTime.fromJSDate(dateObj.date).diff(this.dateRange.start, 'days').values.days);
        Object.assign(this.dateRange, {[dateType]: DateTime.fromJSDate(dateObj.date), 'end': this.dateRange.end.plus({days: diffIndays})})
        this.$emit("preventEmit", true);
      }
      else{
        this.$emit("preventEmit", false);
        Object.assign(this.dateRange, {[dateType]: DateTime.fromJSDate(dateObj.date)})
      }
      this.$emit("update:dateRange", this.dateRange);
    },
    setDateRange(label) {
      if (label==="Custom") {
        this.showCustomRange = true;
      }
      else{
        let [start, end] = this.ranges[label];
        this.$emit("update:dateRangeLabel", label);
        this.$emit("update:avoidUpdatingLabel", true);
        this.$emit("preventEmit", false);
        this.$emit(
            "update:dateRange", 
            Object.assign(this.dateRange, {
                    start,
                    end
                })
        ); 
        this.$emit('update:showDatepicker', false);
        if (this.type == 'month'){
          this.$emit("preventEmit", true);
          this.setMonthRanges(new Date(start), new Date(end));
        }
      }
    },
    setMonthRanges(fromDate, toDate){
      this.monthRange.from =  {
          "from": new Date(fromDate.getFullYear(), fromDate.getMonth(), 0),
          "to": new Date(fromDate.getFullYear(), fromDate.getMonth()+1, 0),
          "month": fromDate.toLocaleString('default', { month: 'long' }),
          "monthIndex":fromDate.getMonth()+1,
          "year":fromDate.getFullYear(),
          "rangeFrom": null, "rangeTo": null, "rangeFromMonth": null, "rangeToMonth": null 
        } ;
        this.monthRange.to = {
          "from":new Date(toDate.getFullYear(), toDate.getMonth(), 0),
          "to": new Date(toDate.getFullYear(), toDate.getMonth()+1, 0),
        "month": toDate.toLocaleString('default', { month: 'long' }),
        "monthIndex": toDate.getMonth() + 1,
        "year": toDate.getFullYear(),
        "rangeFrom": null, "rangeTo": null, "rangeFromMonth": null, "rangeToMonth": null
      };
    },
    handleMonthClick(monthType, dateObj) {
      if (monthType == 'start') {
        var diffIndays = Math.ceil(DateTime.fromJSDate(dateObj.from).diff(this.dateRange.start, 'days').values.days);
        Object.assign(this.dateRange, { [monthType]: DateTime.fromJSDate(dateObj.from), 'end': this.dateRange.end.plus({ days: diffIndays }) })
        Object.assign(this.monthRange, { 'from': dateObj })
        let toDate = new Date(this.dateRange.end);
        Object.assign(this.monthRange, {
          'to': {
            "from": new Date(toDate.getFullYear(), toDate.getMonth(), 0),
            "to": new Date(toDate.getFullYear(), toDate.getMonth() + 1, 0),
            "month": toDate.toLocaleString('default', { month: 'long' }),
            "monthIndex": toDate.getMonth() + 1,
            "year": toDate.getFullYear(),
            "rangeFrom": null, "rangeTo": null, "rangeFromMonth": null, "rangeToMonth": null
          }
        })
          this.monthRange.to= dateObj;
          Object.assign(this.monthRange, {'to':dateObj} )
        this.$emit("preventEmit", true);
      }
      else{
        this.$emit("preventEmit", true);
        Object.assign(this.dateRange, {[monthType]: DateTime.fromJSDate(dateObj.from).endOf("month")});
        Object.assign(this.monthRange, {'to':dateObj})
      }
      this.$emit("update:dateRange", this.dateRange);
    },
  },
  computed: {
      dateRangeFormatted() {
        return `${this.$formatDate(this.dateRange.start)} — ${this.$formatDate(this.dateRange.end)}`;
      },
      dateRangeLabels() {
        return [...Object.keys(this.ranges), "Custom"];
      },
      comparisonDateRanges() {
        // This is a variable that holds the time of each start and end date to use for comparison
        return Object.entries(this.ranges).map(([key, value]) => {
          return [
            key,
            value.map(dateObj => dateObj.getTime())
          ];
        });
      },
    },
    watch: {
      showDatepicker(value) {
        this.showCustomRange = false;
      }
    }
  };
</script>

<style scoped lang="scss">
@import './MobileDateRangePicker.scss';
</style>
